<div class="d-flex justify-content-between">
  <h2 class="pb-0" mat-dialog-title>{{'MANAGE_COLUMNS'|translate}}</h2>
  <div class="d-flex justify-content-center align-items-center">
    <button mat-icon-button (click)="closeDialog()" class="close-btn">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
<mat-dialog-content>
  <div class="checkbox-list">
    <div *ngFor="let column of selectedColumns" class="checkbox-item">
      <mat-checkbox
        [(ngModel)]="column.isShow"
        *ngIf="column.column != 'blank'"
      >
        {{ column.columnTitle }}
      </mat-checkbox>
    </div>
  </div>
</mat-dialog-content>
<div class="d-flex justify-content-end">
  <mat-dialog-actions>
    <button
      mat-flat-button
      color="primary"
      (click)="applyChanges()"
      class="px-4"
      cdkFocusInitial
    >
     {{'APPLY'|translate}}
    </button>
  </mat-dialog-actions>
</div>
